export const GITHUB_STACK_FILE_MARKETPLACE = 'https://github.com/marketplace/stack-file';
